export const timing = {
  /**
   * The duration (ms) for quick animations.
   */
  quick: 100,
  slow: 500,
};
